@if (dataLegends) {
  <div
    class="legends-container"
    [class.round-dot-legend]="roundDot"
    [ngClass]="isShortLegend ? 'short-legends-container small-legends-container' : isGridLegend ? 'small-legends-container' : ''">
    @for (item of dataLegendsResult; track item.name; let i = $index) {
      <div class="legends-container-item" [class.small-legend-item]="isGridLegend">
        @if (!(pageTitle === PageTitle.SettingWidget && (item.name === "couponsCopied" || item.name === "share") && !item.value)) {
          <div class="legends-container-item-legend" [class.short-legend-item]="isShortLegend">
            @if (!choosable) {
              <div class="legends-container-item-legend-label" [style.backgroundColor]="item.color"></div>
              @if (item.promptExplainer) {
                <button type="button" class="legends-container-item-legend-name legend-prompt" (click)="openPrompt(item, $event)">
                  {{ "chart.legends." + item.name | translate }}
                </button>
              } @else {
                <span class="legends-container-item-legend-name">
                  {{ inActiveCampaign ? ("generic.total" | translate) + " " : "" }}{{ "chart.legends." + item.name | translate }}
                </span>
              }
            }
            @if (choosable) {
              <label for="dataset{{ i }}" class="checkbox-wrapper">
                <input
                  type="checkbox"
                  [value]="item.name"
                  id="dataset{{ i }}"
                  [checked]="item.selected"
                  (change)="toggleDatasetChart.emit({ event: $event, index: i })" />
                <span class="checkbox-view" [style.background]="item.selected ? item.color : 'transparent'"></span>
                <span class="text-wrapper">
                  <span [ngClass]="!item.selected ? 'not-selected' : 'selected'">
                    {{
                      item.translationKey
                        ? ("chart.legends." + item.translationKey | translate)
                        : inActiveCampaign
                          ? ("generic.total" | translate) + " "
                          : ("" + "chart.legends." + item.name | translate)
                    }}
                  </span>
                  @if (item.explainer) {
                    <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(item.explainer, $event)">info_outline</mat-icon>
                  }
                </span>
              </label>
            }
          </div>
          @if (item.value !== undefined) {
            <div class="legends-container-item-value" [ngClass]="!item.selected && choosable ? 'not-selected' : item.selected && choosable ? 'selected' : null">
              <span class="legends-container-item-value-data">{{ item.value | thousandSuffix: 1 }}</span>
              @if (item.currency) {
                <span class="legends-container-item-value-currency">{{ item.currency | uppercase }}</span>
              }
              @if (item.percent && item.percent?.value !== 0) {
                <div class="legends-container-item-value-percent">
                  <span class="bracket">(</span>
                  <span class="bracket-content">{{ item.percent }}%</span>
                  <span class="bracket">)</span>
                </div>
              }
            </div>
          }
        }
      </div>
    }
  </div>
}
